import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%", height: "100%" } },
    [
      _c("attribute-filter-panel", {
        attrs: {
          "title-localisation": "attributes.filters.filterByAttributes",
          "filter-count-localisation": "attributes.filters.numApplied",
          "enable-tool-store-group-filter": false,
          "enable-similarity-group-filter": false,
          "enable-cann-group-filter": false,
          "filter-rules": _vm.retailAttributesFilter,
        },
        on: { attributeFilterChange: _vm.setFilterRules },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex similarity-groups-actions" },
        [
          _vm.isSwitchingServiceEnabled &&
          !_vm.isWeeklyWorkpackage &&
          _vm.hasAOExtracts
            ? _c("div", { staticClass: "workflow-controls" }, [
                _c(
                  "div",
                  { staticClass: "d-flex workflow-buttons" },
                  [
                    _c(
                      "tooltip",
                      {
                        staticClass: "switching-status-tooltip",
                        attrs: {
                          value: _vm.generateSwitchingMatrixTooltipMsg,
                          disabled: !_vm.generateSwitchingMatrixTooltipMsg,
                          position: "bottom",
                        },
                      },
                      [
                        _c(
                          VBtn,
                          {
                            attrs: {
                              color: "primary",
                              small: "",
                              depressed: "",
                              disabled: !_vm.canGenerateSwitchingMatrix,
                              loading: _vm.runningSwitching,
                            },
                            on: { click: _vm.generateSwitchingMatrix },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$tkey("actions.generateSwitchingMatrix")
                                ) +
                                "\n            "
                            ),
                            _vm._m(0),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "workflow-controls" }, [
            _c(
              "div",
              { staticClass: "d-flex workflow-buttons" },
              [
                _c(
                  "tooltip",
                  {
                    attrs: {
                      value: _vm.refreshSimGroupsTooltipMsg,
                      disabled: !_vm.refreshSimGroupsTooltipMsg,
                      position: "bottom",
                    },
                  },
                  [
                    _vm.isSwitchingServiceEnabled
                      ? _c(
                          VMenu,
                          {
                            attrs: { "offset-y": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                color: "primary",
                                                small: "",
                                                depressed: "",
                                                disabled:
                                                  !_vm.canRefreshSimilarityGroups,
                                                loading: _vm.runningRefresh,
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$tkey(
                                                  "actions.refreshSimilarityGroups"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                          _c(
                                            VIcon,
                                            { attrs: { size: "2rem" } },
                                            [_vm._v("mdi-menu-down")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1994896135
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              VList,
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  VListItem,
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.refreshSimilarityGroups(
                                          false
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(VListItemTitle, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$tkey(
                                            "actions.refreshSimilarityGroups"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "tooltip",
                                  {
                                    attrs: {
                                      value:
                                        _vm.refreshSimilarityGroupUseProductSwitchingTooltipMsg,
                                      disabled:
                                        !_vm.refreshSimilarityGroupUseProductSwitchingTooltipMsg,
                                      position: "right",
                                    },
                                  },
                                  [
                                    _c(
                                      VListItem,
                                      {
                                        attrs: {
                                          disabled:
                                            !_vm.hasGeneratedSwitchingMatrix,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.refreshSimilarityGroups(
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(VListItemTitle, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$tkey(
                                                "actions.refreshSimilarityGroupsUseProductSwitching"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          VBtn,
                          {
                            attrs: {
                              color: "primary",
                              small: "",
                              depressed: "",
                              disabled: !_vm.canRefreshSimilarityGroups,
                              loading: _vm.runningRefresh,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.refreshSimilarityGroups(false)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$tkey("actions.refreshSimilarityGroups")
                                ) +
                                "\n            "
                            ),
                            _vm._m(1),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "workflow-info-row" },
              [
                _c("last-triggered-info", {
                  staticClass: "mr-0",
                  attrs: {
                    "last-triggered-info": _vm.lastTriggeredInfo,
                    loading: _vm.isLastTriggeredLoading,
                    "translation-time-key":
                      "settings.similarityGroups.lastRefreshTime",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "workflow-controls" }, [
            _c(
              "div",
              { staticClass: "d-flex workflow-buttons" },
              [
                _c(
                  "tooltip",
                  {
                    attrs: {
                      value: _vm.refreshParamsTooltipMsg,
                      disabled: !_vm.refreshParamsTooltipMsg,
                      position: "bottom",
                    },
                  },
                  [
                    _vm.isSwitchingServiceEnabled
                      ? _c(
                          VMenu,
                          {
                            attrs: { "offset-y": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                color: "primary",
                                                small: "",
                                                depressed: "",
                                                disabled:
                                                  !_vm.canRefreshXEOParams,
                                                loading: _vm.runningXEORefresh,
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$tkey(
                                                  "actions.refreshXEOParams"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                          _c(
                                            VIcon,
                                            { attrs: { size: "2rem" } },
                                            [_vm._v("mdi-menu-down")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3904159957
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              VList,
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  VListItem,
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.refreshXEOParams(false)
                                      },
                                    },
                                  },
                                  [
                                    _c(VListItemTitle, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$tkey("actions.refreshXEOParams")
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "tooltip",
                                  {
                                    attrs: {
                                      value:
                                        _vm.refreshXEOParamsUseProductSwitchingTooltipMsg,
                                      disabled:
                                        !_vm.refreshXEOParamsUseProductSwitchingTooltipMsg,
                                      position: "right",
                                    },
                                  },
                                  [
                                    _c(
                                      VListItem,
                                      {
                                        attrs: {
                                          disabled:
                                            !_vm.hasGeneratedSwitchingMatrix,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.refreshXEOParams(true)
                                          },
                                        },
                                      },
                                      [
                                        _c(VListItemTitle, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$tkey(
                                                "actions.refreshXEOParamsUseProductSwitching"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          VBtn,
                          {
                            attrs: {
                              color: "primary",
                              small: "",
                              depressed: "",
                              disabled: !_vm.canRefreshXEOParams,
                              loading: _vm.runningXEORefresh,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.refreshXEOParams(false)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$tkey("actions.refreshXEOParams")) +
                                "\n            "
                            ),
                            _vm._m(2),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "workflow-info-row" },
              [
                _c("last-triggered-info", {
                  staticClass: "mr-0",
                  attrs: {
                    "last-triggered-info": _vm.lastTriggeredXEOInfo,
                    loading: _vm.isLastTriggeredLoading,
                    "translation-time-key":
                      "settings.similarityGroups.lastRefreshTime",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("similarity-groups-upload", {
            attrs: {
              disabled: _vm.isMasterWorkpackage || _vm.isWeeklyWorkpackage,
            },
          }),
          _vm._v(" "),
          _c(
            VBtn,
            {
              attrs: { color: "primary", small: "", depressed: "" },
              on: { click: _vm.exportSimilarityGroups },
            },
            [
              _c(VIcon, { attrs: { small: "" } }, [_vm._v("$export")]),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("actions.download")) + "\n    "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VBtn,
            {
              staticClass: "inputs-actions__columns grid-btn pa-0",
              attrs: { secondary: "", small: "", depressed: "" },
              on: {
                click: function ($event) {
                  return _vm.toggleSideBar("columns")
                },
              },
            },
            [
              _c(VIcon, { staticClass: "mr-1" }, [
                _vm._v("mdi-view-column-outline"),
              ]),
              _vm._v("\n      " + _vm._s(_vm.$t("inputs.columns")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ag-grid-vue", {
        staticClass: "ag-theme-custom ag-similarity-groups-grid",
        style: { width: "100%", height: `70rem` },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "fill-operation": _vm.fillOperation,
          "side-bar": _vm.sideBar,
        },
        on: {
          "grid-ready": _vm.onGridReady,
          "column-visible": _vm.onColumnVisible,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3 mr-4 text-right" },
        [
          _c(
            VBtn,
            {
              staticClass: "grid-btn mr-2",
              attrs: {
                secondary: "",
                small: "",
                depressed: "",
                disabled: !_vm.editsExist || _vm.isSaving,
              },
              on: { click: _vm.onDiscard },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("actions.discard")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            VBtn,
            {
              attrs: {
                color: "success",
                small: "",
                depressed: "",
                loading: _vm.isSaving,
                disabled: !_vm.editsExist || _vm.isSaving,
              },
              on: { click: _vm.onSave },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("actions.save")) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("common-dialog", {
        attrs: {
          "is-open": _vm.isEditDialogOpen,
          "header-text": _vm.$tkey("headers.editGroupName"),
          "ok-btn-text": _vm.$t("actions.save"),
          "ok-btn-disabled": !_vm.isEditFormValid,
        },
        on: { onOk: _vm.openEditConfirm, onCancel: _vm.cancelEdit },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VForm,
                  {
                    ref: "editForm",
                    model: {
                      value: _vm.isEditFormValid,
                      callback: function ($$v) {
                        _vm.isEditFormValid = $$v
                      },
                      expression: "isEditFormValid",
                    },
                  },
                  [
                    _c(
                      VRow,
                      { staticClass: "mt-4", attrs: { "no-gutters": "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "12" } },
                          [
                            _c(VAutocomplete, {
                              attrs: {
                                items: _vm.similarityGroupOptions,
                                label: _vm.$tkey(
                                  "actions.selectSimilarityGroup"
                                ),
                                dense: "",
                                rules: [_vm.valueRequired],
                              },
                              model: {
                                value: _vm.selectedSimilarityGroupKey,
                                callback: function ($$v) {
                                  _vm.selectedSimilarityGroupKey = $$v
                                },
                                expression: "selectedSimilarityGroupKey",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "12" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                label: _vm.$tkey("actions.changeToNewName"),
                                rules: [_vm.valueRequired, _vm.isNameUnique],
                              },
                              model: {
                                value: _vm.newSimilarityGroupName,
                                callback: function ($$v) {
                                  _vm.newSimilarityGroupName =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "newSimilarityGroupName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("confirm-dialog", {
        attrs: {
          "is-open": _vm.isEditConfirmDialogOpen,
          "ok-btn-text": _vm.$t("actions.yesProceed"),
        },
        on: { onOk: _vm.confirmEdit, onCancel: _vm.cancelEdit },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$tkey("dialogs.editConfirm", {
                          group: _vm.selectedSimilarityGroupName,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.$tkey("dialogs.areYouSureToProceed"))),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("common-dialog", {
        attrs: {
          "is-open": _vm.isCreateDialogOpen,
          "header-text": _vm.$tkey("dialogs.createTitle"),
          "ok-btn-text": _vm.$t("actions.create"),
          "ok-btn-disabled": !_vm.isCreateFormValid,
        },
        on: { onOk: _vm.confirmCreate, onCancel: _vm.cancelCreate },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.createDialogProduct
                  ? _c(
                      VForm,
                      {
                        ref: "createForm",
                        model: {
                          value: _vm.isCreateFormValid,
                          callback: function ($$v) {
                            _vm.isCreateFormValid = $$v
                          },
                          expression: "isCreateFormValid",
                        },
                      },
                      [
                        _c(
                          VRow,
                          { staticClass: "mt-2", attrs: { "no-gutters": "" } },
                          [
                            _c(VCol, { attrs: { cols: "12" } }, [
                              _c(
                                "div",
                                { staticClass: "text-subtitle-2 mb-2" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$tkey("dialogs.productContext"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml-4" }, [
                                _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$tkey("headers.productKeyDisplay")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.createDialogProduct
                                          .productKeyDisplay
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$tkey("dialogs.cannGroupLabel")
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.createDialogProduct.cannGroup
                                          .cannGroupName
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$tkey("dialogs.uomLabel")) +
                                        ":"
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.createDialogProduct
                                          .contentUnitOfMeasure
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          VRow,
                          { staticClass: "mt-4", attrs: { "no-gutters": "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.$tkey("dialogs.enterName"),
                                    rules: [
                                      _vm.valueRequired,
                                      _vm.isCreateNameUnique,
                                    ],
                                    autofocus: "",
                                  },
                                  model: {
                                    value: _vm.newGroupName,
                                    callback: function ($$v) {
                                      _vm.newGroupName =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "newGroupName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { attrs: { size: "2rem" } }, [_vm._v("mdi-matrix")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { attrs: { size: "2rem" } }, [_vm._v("mdi-refresh")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(VIcon, { attrs: { size: "2rem" } }, [_vm._v("mdi-refresh")])
  },
]
render._withStripped = true

export { render, staticRenderFns }